<template>
  <div>
    <div v-if="isDocumentsVisible" class="resources-container">
      <div class="card-container">
        <div v-for="doc in documents"
          :key="doc.id"
          class="card">
          <ResourceCard
            :resource="doc"
            @isDownloading="setDownloading(true)"
            @isDownloadComplete="setDownloading(false)"
          >
          </ResourceCard>
        </div>
      </div>
    </div>
    <div v-if="isLoading || isDownloading">
      <IconLoading :loadingText="loadingMessage"></IconLoading>
    </div>
    <div v-if="!isDocumentsVisible && !isLoading" class="no-documents">
      <div>Currently, there are no resource documents available.</div>
      <div v-if="isError"></div>
    </div>
  </div>
</template>

<script setup>
import {
  reactive, ref, computed, onMounted,
} from 'vue';
import apiManager from '@/api';
import IconLoading from '@/components/loaders/IconLoading.vue';
import ResourceCard from '../components/resources/ResourceCard.vue';

const documents = reactive([]);

const isDocumentsVisible = computed(() => documents.length > 0);

const isDownloading = ref(false);

const loadingMessage = computed(() => {
  if (isDownloading.value) {
    return 'Downloading resource';
  }
  return 'Retrieving resources';
});

function setDownloading(isTrue) {
  isDownloading.value = isTrue;
}

const errorMessage = ref('');

const isError = computed(() => errorMessage.value !== '');

const isLoading = ref(true);

onMounted(() => {
  try {
    documents.length = 0; // remove all items in the array
    apiManager.dashboardResouce.GetActive()
      .then((data) => {
        documents.push(...data);
        isLoading.value = false;
      });
  } catch {
    errorMessage.value = 'An error occurred while trying to fetch resources.';
    isLoading.value = false;
  }
});
</script>

<style lang="css" scoped>
  .resources-container {
    margin-top: 20px;
  }

  .card-container {
    display: flex;
    flex-wrap: wrap;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }

  .card {
    flex: 1;
    margin: 10px;
  }

  .no-documents {
    margin-top: 40px;
    margin-left: 20px;
    font-size: 1.5rem;
  }

</style>
